export const MY_SESSIONS_ONE_TO_ONE_REQUEST = 'mySessionsOneToOneReducer/MY_SESSIONS_ONE_TO_ONE_REQUEST';
export const MY_SESSIONS_ONE_TO_ONE_SUCCESS = 'mySessionsOneToOneReducer/MY_SESSIONS_ONE_TO_ONE_SUCCESS';
export const MY_SESSIONS_ONE_TO_ONE_FAILED = 'mySessionsOneToOneReducer/MY_SESSIONS_ONE_TO_ONE_FAILED';